var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"segmented-colored-progressbar"},[_c('div',{staticClass:"segmented-colored-progressbar__bar"},_vm._l((_vm.items),function(item){return _c('div',_vm._b({staticClass:"segmented-colored-progressbar__bar_progress",style:({ background:item.color })},'div',item,false))}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }